// extracted by mini-css-extract-plugin
export default {"container":"ppa26"};